import { makeStyles } from '@mui/styles';
import basicTheme from './basicTheme.js';

const useGlobalStyles = makeStyles({
    '@global': {
        '.styled-scrollbar': {
            '&::-webkit-scrollbar, & *::-webkit-scrollbar': {
                backgroundColor: 'transparent',
                width: '14px',
            },
            '&::-webkit-scrollbar-corner , & *::-webkit-scrollbar-corner ': {
                backgroundColor: 'transparent',
            },
            '&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb': {
                transition: 'background-color 100ms linear',
                borderRadius: '9999px',
                minHeight: '24px',
                backgroundColor: basicTheme.palette.N30.main,
                border: `4px solid transparent`,
                backgroundClip: 'padding-box',
                '&:hover': {
                    backgroundColor: basicTheme.palette.primary.dark,
                },
            },
        },
        '.hidden-scrollbar': {
            '&::-webkit-scrollbar, & *::-webkit-scrollbar': {
                display: 'none',
            },
            '&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb': {
                display: 'none',
            },
        },
        '.always-Y-scrollbar': {
            overflowY: 'scroll !important',
        },
    },
});

export { useGlobalStyles as default };
//# sourceMappingURL=global.js.map
